import { render, staticRenderFns } from "./trailing.vue?vue&type=template&id=3046d632&scoped=true"
import script from "./trailing.vue?vue&type=script&lang=js"
export * from "./trailing.vue?vue&type=script&lang=js"
import style0 from "./trailing.vue?vue&type=style&index=0&id=3046d632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3046d632",
  null
  
)

export default component.exports